module.exports = __webpack_public_path__ + "img/ajans-press-courier-ad-04.1c57d495.jpg";